module.exports = __webpack_public_path__ + "img/drizzle.d3ec874b.svg";